import React from "react";
import { Navigate } from "react-router-dom";
import { useKeycloak } from '@react-keycloak/web';

export default function PrivateRoute({ children, requiredRole = "user", skeleton: SkeletonComponent = null }) {
  const { keycloak, initialized } = useKeycloak();
  const ROLES = ['user', 'superuser', 'admin'];

  if (!ROLES.includes(requiredRole)) {
    throw new Error("Role requerida é inválida");
  }

  if (!initialized) {
    return SkeletonComponent ? (
      <SkeletonComponent />
    ) : (
      <div>Carregando...</div>
    );
  }

  if (!keycloak.authenticated) {
    return <Navigate to="/login" state={{ from: window.location.pathname }} />;
  }

  function getUserHighestRole() {
    if (keycloak.hasRealmRole("admin")) return "admin";
    if (keycloak.hasRealmRole("superuser")) return "superuser";
    return "user";
  }
  const userRole = getUserHighestRole();

  if (ROLES.indexOf(userRole) < ROLES.indexOf(requiredRole)) {
    return <Navigate to="/" />;
  }

  const isLocked = keycloak.hasRealmRole("locked") ? true : false;

  if (!isLocked && window.location.pathname === "/locked") {
    return <Navigate to="/" />;
  }

  //if (isLocked && window.location.pathname !== "/locked") {
  //  return <Navigate to="/locked" />; //TODO: Implementar tela '/locked'
  //}

  return children;
}
